const hasContexts = (contexts: Array<string>) => contexts.every(context => window.contexts.includes(context));

import widgetsMgr from 'widgets/widgetsMgr';

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContexts(['checkout']),
    load: () =>
        Promise.all([import(/* webpackChunkName: 'checkout.kcp' */ './widgets/checkout/PaymentAccordionItemKCP').then(d => d.default)]).then(deps => {
            const [PaymentAccordionItemKCP] = deps;

            return {
                listId: 'checkout.KCP',
                widgetsDefinition: () => [['paymentAccordionItemKCP', PaymentAccordionItemKCP, 'paymentAccordionItem']]
            };
        })
});
